import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs/operators';
import { FpOrganizationResource, Organization } from 'src/app/client-api.service';
import { OrganizationService } from 'src/app/core-services/organization.service';
import { MaintenanceService } from '../../services/maintenance.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY } from 'rxjs';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-organization-upsert',
  templateUrl: './organization-upsert.component.html',
  styleUrls: [ './organization-upsert.component.scss'
  ]
})
export class OrganizationUpsertComponent implements OnInit {

  addOrEdit: 'add' | 'edit';
  currentId = 0;
  currentOrgannization: Organization | undefined;
  orgs$ = this.organizationService.organizations$;
  organizationFormGroup = new FormGroup({
      orgId: new FormControl(0, { nonNullable: true }),
      orgCode: new FormControl('', { nonNullable: true, validators: Validators.required }),      
      name: new FormControl('', { nonNullable: true, validators: Validators.required }),
      accountingMethodType: new FormControl('', { nonNullable: true }),
      metaJson: new FormControl('', { nonNullable: true }),
      lagMonth: new FormControl(0, { nonNullable: true, validators: Validators.required })  ,
      propertyTypeName: new FormControl('', { nonNullable: true }),
      entrataPropertyId: new FormControl('', { nonNullable: true })    
    });
  panalSize: PanelSize = 'large';
  state: 'initializing' | 'loading' | 'ready' | 'saving';  


  constructor( private activatedRoute: ActivatedRoute,
               private maintenanceService: MaintenanceService,
               private organizationService: OrganizationService,
               private router: Router) { 
    this.addOrEdit = 'edit';
    this.state = 'initializing';
  }

  ngOnInit(): void {
  
      this.activatedRoute.params.subscribe(routeParam => {
      this.currentId =  routeParam['orgId'];      
      if(routeParam['orgId'] !== '0') {
        this.addOrEdit = 'edit';
        this.setCurrentOrganization(this.currentId);        
      }     
    });    
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

    isChanged(field: string) {
    return this.organizationFormGroup.get(field)?.dirty;
  }

  setCurrentOrganization(orgId: number) {
    this.orgs$.pipe(
      map(org => {        
        return org.find(o => o.orgId === parseInt(orgId.toString(), 10)); 
      }),      
      tap(org => {
        this.currentOrgannization = org;
         this.organizationFormGroup.patchValue({
              orgId: org!.orgId,
              orgCode: org!.orgCode,
              name: org!.name,
              accountingMethodType: org!.accountingMethod,
              metaJson: org!.metaJson,
              lagMonth: org!.lagMonth,
              propertyTypeName: org!.propertyTypeName,
              entrataPropertyId: org!.entrataPropertyId
            });
        this.state = 'ready';
      }),
      catchError((err) => {
        alert('Error setting the current Organization!');
        console.log(err);
        return EMPTY; 
      })
    ).subscribe();
  }

  onSubmit() {

    const formValue = this.organizationFormGroup.getRawValue();
    const fpOrganizationResource: FpOrganizationResource = {
      orgId: formValue.orgId,
      orgCode: formValue.orgCode,
      name: formValue.name,
      accountingMethodType: this.getAccountingMethodValue(formValue.accountingMethodType)!,
      metaJson: formValue.metaJson,
      lagMonth: formValue.lagMonth,
      propertyTypeName: formValue.propertyTypeName,
      entrataPropertyId: formValue.entrataPropertyId
    };
    
    this.organizationService.putOrganization(fpOrganizationResource).subscribe(
      res => {
        this.organizationService.setOrganizations();
        this.close();
      },
      err => {
        alert('Error seetting Organizations!');
      });
  }
  
  getAccountingMethodValue(accountingMethod: string): number | undefined {
    switch(accountingMethod){
      case 'All':
        return 0;
      case 'Accrual':
        return 1;
      case 'Cash':
        return 2;
      default:
        return undefined;
    }
  }

}
